import {
  REIUMBURSEMENT_TABS_DATA_SUCCESS,
  REIUMBURSEMENT_TABS_DATA_FAILURE,
  REIUMBURSEMENT_TABS_DATA_LOADING,
  REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_SUCCESS,
  REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_FAILURE,
  REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_LOADING,
  REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_SUCCESS,
  REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_FAILURE,
  REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_LOADING,
  REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_SUCCESS,
  REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_FAILURE,
  REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_LOADING,
  REIUMBURSEMENT_TABS_NONPAYMENT_REQUEST,
  REIUMBURSEMENT_TABS_NONPAYMENT_SUCCESS,
  REIUMBURSEMENT_TABS_NONPAYMENT_FAILURE,
  REIUMBURSEMENT_TABS_NONPAYMENT_LOADING,
  REIUMBURSEMENT_TABS_POLLING_STARTED,
  REIUMBURSEMENT_TABS_POLLING_COMPLETED,
  REIUMBURSEMENT_TABS_POLLING_FAILED,
  REIUMBURSEMENT_TABS_POLLING_RESET
} from '@src/middleware/actions/actionTypes';

interface ReiumbursementTabState {
  reiumbursementTabsData: any;
  reiumbursementTabsDataDopFilters?: any;
  reiumbursementTabsNonPayment?: any;
  isLoading: boolean;
  reiumbursementAppealsTabData: any;
  reiumbursementReconsiderationTabData?: any;
  pollingCount: number;
  pollingError: any;
  tinCount?: number; // TIN count from API for GEO flow
}

const initialState: ReiumbursementTabState = {
  isLoading: false,
  reiumbursementTabsData: {},
  reiumbursementTabsDataDopFilters: {},
  reiumbursementTabsNonPayment: {},
  reiumbursementAppealsTabData: {},
  reiumbursementReconsiderationTabData: {},
  pollingCount: 0,
  pollingError: null,
  tinCount: undefined,
};

const ReiumbursementTabsReducer = (
  state = initialState,
  action: { type: string; payload?: any, url?: any }
): ReiumbursementTabState => {
  switch (action.type) {
    case REIUMBURSEMENT_TABS_DATA_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        ...(action.payload ? { reiumbursementTabsData: {}, reiumbursementTabsDataDopFilters: {} } : {}),
      };

    case REIUMBURSEMENT_TABS_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reiumbursementTabsData: action.payload || {},
        reiumbursementTabsDataDopFilters: {},
        tinCount: action.payload?.paymentMetricTinCount ?? action.payload?.initialData?.TinCount ?? action.payload?.Data?.TinCount,
      };

    case REIUMBURSEMENT_TABS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        reiumbursementTabsData: {},
      };

    case REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        ...(action.payload ? { reiumbursementAppealsTabData: {} } : {}),
      };

    case REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reiumbursementAppealsTabData: action.payload || {},
      };

    case REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        reiumbursementAppealsTabData: {},
      };

    case REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        ...(action.payload ? { reiumbursementReconsiderationTabData: {} } : {}),
      };
    case REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reiumbursementReconsiderationTabData: action.payload || {},
      };
    case REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        reiumbursementReconsiderationTabData: {},
      };
    case REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        ...(action.payload ? { reiumbursementTabsDataDopFilters: {} } : {}),
      };
    case REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reiumbursementTabsDataDopFilters: action.payload || {},
        reiumbursementTabsData: {},
        tinCount: action.payload?.TinCount ?? action.payload?.Data?.TinCount,
      };
    case REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        reiumbursementTabsDataDopFilters: {}
      };

    case REIUMBURSEMENT_TABS_NONPAYMENT_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        ...(action.payload ? { reiumbursementTabsNonPayment: {} } : {}),
      };
    case REIUMBURSEMENT_TABS_NONPAYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reiumbursementTabsNonPayment: action.payload || {},
      };
    case REIUMBURSEMENT_TABS_NONPAYMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        reiumbursementTabsNonPayment: {},
      };

    case REIUMBURSEMENT_TABS_POLLING_STARTED:
      if (sessionStorage.getItem('reimbursementPolling') === null) {
        const arr = [action.url];
        sessionStorage.setItem('reimbursementPolling', JSON.stringify(arr));
      } else {
        const currentPolling = JSON.parse(sessionStorage.getItem('reimbursementPolling') || '[]');
        currentPolling.push(action.url);
        sessionStorage.setItem('reimbursementPolling', JSON.stringify(currentPolling));
      }
      window.dispatchEvent(new CustomEvent('sessionStorageChanged', {
        detail: { key: 'reimbursementPolling', value: JSON.parse(sessionStorage.getItem('reimbursementPolling') || "[]")?.length }
      }));
      return {
        ...state,
        pollingCount: state.pollingCount + 1,
        pollingError: null,
      };

  case REIUMBURSEMENT_TABS_POLLING_COMPLETED:
    const arr = JSON.parse(sessionStorage.getItem('reimbursementPolling') || "[]");
    const updated = arr.filter(x => x !== action.url);
    sessionStorage.setItem('reimbursementPolling', JSON.stringify(updated));

    window.dispatchEvent(new CustomEvent('sessionStorageChanged', {
      detail: { key: 'reimbursementPolling', value: JSON.parse(sessionStorage.getItem('reimbursementPolling') || "[]")?.length }
    }));
    return {
      ...state,
      pollingCount: Math.max(0, state.pollingCount - 1),
      pollingError: null,
    };

  case REIUMBURSEMENT_TABS_POLLING_FAILED:
    // Don't touch sessionStorage here — POLLING_COMPLETED in the saga's finally block
    // will handle removing the correlationId from sessionStorage
    return {
      ...state,
      pollingError: action.payload,
    };

  case REIUMBURSEMENT_TABS_POLLING_RESET:
    sessionStorage.removeItem('reimbursementPolling');
    return {
      ...state,
      pollingCount: 0,
      pollingError: null,
    };
    default:
      return state;
  }
};

export default ReiumbursementTabsReducer;
